import { SVGAttributes } from 'react';

export default function BookmarkSVG(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            {...props}
            className="icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12 19.2L8.475 20.625C7.89167 20.8583 7.33333 20.7958 6.8 20.4375C6.26667 20.0792 6 19.5833 6 18.95V6.59999C6 6.09999 6.175 5.67499 6.525 5.32499C6.875 4.97499 7.3 4.79999 7.8 4.79999H16.2C16.7 4.79999 17.125 4.97499 17.475 5.32499C17.825 5.67499 18 6.09999 18 6.59999V18.95C18 19.5833 17.7333 20.0792 17.2 20.4375C16.6667 20.7958 16.1083 20.8583 15.525 20.625L12 19.2Z" />
        </svg>
    );
}
